export default __webpack_public_path__ + "static/media/filterIcon.520c3818.svg";